if (!customElements.get('mini-menu')) {
  customElements.define(
    'mini-menu',
    class MiniMenu extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;

        this.select = this.querySelector('[data-mini-menu-select]');
        this.select?.addEventListener('change', (event) => this.handleChange(event));

        this.querySelectorAll('[data-mini-menu-link]').forEach((link) => {
          link.addEventListener('click', (event) => this.handleClick(event));
        });
      }

      get anchorOffset() {
        return parseInt(this.dataset.anchorOffset || '0', 10);
      }

      handleChange(event) {
        const target = event.target.value;
        if (!target) return;

        this.scrollToAnchor(target);
      }

      handleClick(event) {
        const hash = event.currentTarget.getAttribute('href');
        if (!hash || !hash.startsWith('#')) return;

        event.preventDefault();
        this.scrollToAnchor(hash.slice(1));
      }

      scrollToAnchor(anchorId) {
        const target = this.getTarget(anchorId);
        if (!target) return;

        const top = target.getBoundingClientRect().top + window.scrollY - this.getOffset();
        window.scrollTo({
          top,
          behavior: 'smooth'
        });

        history.pushState(null, '', `#${anchorId}`);
      }

      getTarget(anchorId) {
        const decodedAnchor = decodeURIComponent(anchorId);

        if (window.CSS?.escape) {
          return document.getElementById(decodedAnchor) || document.querySelector(`#${CSS.escape(decodedAnchor)}`);
        }

        return document.getElementById(decodedAnchor);
      }

      getOffset() {
        const rootStyle = getComputedStyle(document.documentElement);
        const stickyHeaderHeight = parseFloat(rootStyle.getPropertyValue('--sticky-header-height')) || 0;
        const headerHeight = parseFloat(rootStyle.getPropertyValue('--header-height')) || 0;
        const visibleHeader = document.querySelector('.shopify-section-header, .header-section, header');
        const visibleHeaderHeight = visibleHeader ? visibleHeader.getBoundingClientRect().height : 0;

        return Math.max(stickyHeaderHeight, headerHeight, visibleHeaderHeight) + this.anchorOffset;
      }
    }
  );
}
